import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { isLoggedInAtom } from '@root/entities/auth'
import { Deeplink, DeeplinkURL } from '@root/entities/deeplinking'
import { PlatformUtil } from '@root/shared'
import { routerActions } from '@root/shared/lib/react-router'
import { showSnackbarAction } from '@root/shared/ui-kit'
import { searchModalOpenAtom } from '@root/widgets/desktop/search-modal'

import { clipboardPairAtom } from '../pair/atoms/reatom-clipboard-pair'
import { ProfileRoute, TradeRoute } from '../routing'
import { settingScreenAtom } from '../settings/settings-screen'
import { tradingPairAtom } from '../trade/trading'

import { ShortcutId } from './shortcut-id'
import { listenShortcuts } from './shortcut-runner'

import type { ShortcutRouter } from './shortcut-router'
import type { Ctx } from '@reatom/framework'

const KeyShow = {
  Cmd: '⌘',
  Control: '⌃',
  Alt: '⌥',
  Shift: '⇧',
  Enter: '⏎',
}

export const shortcutAppRouter: ShortcutRouter = {
  [ShortcutId.Search]: {
    command: 'ctrl+f,cmd+f',
    commandShow: [`Ctrl + F`, `${KeyShow.Cmd} + F`],
    description: 'shortcuts.open-search-modal',
    handler: async ({ ctx }) => {
      searchModalOpenAtom(ctx, true)
      return Result.void()
    },
  },
  [ShortcutId.Settings]: {
    command: 'ctrl+,,cmd+,',
    commandShow: [`Ctrl + ,`, `${KeyShow.Cmd} + ,`],
    description: 'shortcuts.open-settings-modal',
    handler: async ({ ctx }) => {
      settingScreenAtom(ctx, 'main')

      return Result.void()
    },
  },
  [ShortcutId.Profile]: {
    command: 'ctrl+p,cmd+p',
    commandShow: [`Ctrl + P`, `${KeyShow.Cmd} + P`],
    description: 'shortcuts.open-profile',
    handler: async ({ ctx }) => {
      const isLoggedIn = ctx.get(isLoggedInAtom)

      if (isLoggedIn) {
        routerActions.navigate(ctx, ProfileRoute.build({}))
      }

      return Result.void()
    },
  },
  [ShortcutId.CopyTradeGoto]: {
    command: 'ctrl+c,cmd+c',
    commandShow: [`Ctrl + C`, `${KeyShow.Cmd} + C`],
    description: 'shortcuts.copy-trade-page-link',
    handler: async ({ ctx }) => {
      const pair = ctx.get(tradingPairAtom)
      if (!pair) {
        return Result.void()
      }
      const deeplink = new Deeplink.Trade({
        network: pair.network,
        pair: pair.address,
      })
      const url = DeeplinkURL.fromDeeplink(deeplink)

      const copied = await PlatformUtil.copyToClipboard(url.toString())

      if (copied) {
        showSnackbarAction(ctx, {
          intent: 'success',
          text: i18next.t('trading.pair.share-link-copied'),
        })
        return Result.void()
      } else {
        return Result.fail(void 0)
      }
    },
  },
  [ShortcutId.OpenClipboardPair]: {
    command: 'alt+v,option+v',
    commandShow: [`Alt + V`, `${KeyShow.Alt} + V`],
    description: 'shortcuts.open-clipboard-pair',
    handler: async ({ ctx }) => {
      const pair = ctx.get(clipboardPairAtom)
      if (!pair) {
        return Result.void()
      }
      routerActions.navigate(
        ctx,
        TradeRoute.build({
          pairAddress: pair.address,
          network: pair.network,
        }),
      )
      return Result.void()
    },
  },
}

export const listenAppShortcuts = (ctx: Ctx) =>
  listenShortcuts({ ctx, router: shortcutAppRouter })
